import * as React from "react";
import { runHattrickOn } from "../../../API/hattrick";
import { useUserContext } from "../../../contexts/ProviderProvider";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import {
    Table,
    TableContainer,
    Typography,
    Paper,
    TableCell,
    TableRow,
    TableBody,
    TableHead,
    Button,
    Checkbox,
    Tooltip,
} from "@mui/material";
import useNotification from "../../../hooks/useNotification";
import { useNavigate } from "react-router";
import LazyImage from "../../common/LazyImage";

const formatDateString = (inputString) => {
    const date = new Date(inputString);

    const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZoneName: "short",
    };

    return date.toLocaleString("en-US", options);
};

const HattrickTeamProductReadyTable = ({ data, refresh, currentlyRunning }) => {
    const user = useUserContext();
    const notify = useNotification();
    const navigate = useNavigate();

    if (!data) {
        return (
            <Typography>
                No Team products ready for this school sport combination
            </Typography>
        );
    }

    const runHattrickOnProduct = async (productId, teamId) => {
        try {
            const response = await runHattrickOn(
                {
                    team_running: [{ type_id: productId, team_id: teamId }],
                    type: "team products",
                },
                user
            )

            console.log('response running team products: ', response)
        } catch (error) {
            console.error('error while starting hattrick on team products ', error)
            notify("Failed to start hattrick on team products");
        } finally {
            refresh();
        }
    };


    const isRunning = (row) => {
        return currentlyRunning.filter((cr) => cr.type_id === row.team_product_id).length > 0
    };

    return (
        <div>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Hint</TableCell>
                            <TableCell>Team ID</TableCell>
                            <TableCell>Team Product ID</TableCell>
                            <TableCell>University Name</TableCell>
                            <TableCell>Sku Name</TableCell>
                            <TableCell>Sport</TableCell>
                            <TableCell>Front</TableCell>
                            <TableCell>Back</TableCell>
                            <TableCell>Photo</TableCell>
                            <TableCell>Run</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((row) => (
                            <TableRow
                                key={row.team_product_id}
                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                            >
                                <TableCell>
                                    {row.message && row.message !== "" && (
                                        <Tooltip
                                            title={
                                                <>
                                                    <p>{formatDateString(row.timestamp)}</p>
                                                    <p>{row.message}</p>
                                                </>
                                            }
                                        >
                                            <PriorityHighIcon color="error" />
                                        </Tooltip>
                                    )}
                                </TableCell>
                                <TableCell>{row.team_id}</TableCell>
                                <TableCell>{row.team_product_id}</TableCell>
                                <TableCell>
                                    <Button
                                        sx={{ textTransform: "unset" }}
                                        onClick={() =>
                                            navigate("/ballpark/athletes/" + btoa(row.RosterId))
                                        }
                                    >
                                        {row.school_name}
                                    </Button>
                                </TableCell>
                                <TableCell>{row.sku_name}</TableCell>
                                <TableCell>{row.sport}</TableCell>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ padding: "25px" }}
                                >
                                    <Checkbox checked={row.front_asset ? true : false} />
                                </TableCell>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ padding: "25px" }}
                                >
                                    <Checkbox checked={row.back_asset ? true : false} />
                                </TableCell>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ padding: "25px" }}
                                >
                                    {row.photo ? (
                                        <LazyImage
                                            alt={"prooduct asset"}
                                            style={{ maxHeight: "25px" }}
                                            src={row.photo}
                                            onClick={() => {
                                                window.open(row.photo, "_blank");
                                            }}
                                        />
                                    ) : (
                                        <Typography>No Mockup</Typography>
                                    )}
                                </TableCell>
                                <TableCell>
                                    <Button
                                        disabled={isRunning(row)}
                                        variant="contained"
                                        onClick={() =>
                                            runHattrickOnProduct(row.team_product_id, row.team_id)
                                        }
                                    >
                                        Run
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default HattrickTeamProductReadyTable;
